import CheckboxSendInvitation from './CheckboxSendInvitation'

export default CheckboxSendInvitation
